import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import * as React from "react";

export default function DateSelector({ onSelect, date }) {
  const handleDateChange = (date) => {
    onSelect(date.toDate());
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* <DemoContainer components={["DatePicker"]}> */}
      <DatePicker
        label="Date used"
        value={dayjs(date)}
        onChange={handleDateChange}
      />
      {/* </DemoContainer> */}
    </LocalizationProvider>
  );
}
